import { toHeaders, doFetch } from '../utils/util';

const MAGAZINE_CREATE_URL = '/magazine-page/create';
const MAGAZINE_UPLOAD_URL = '/magazine-page/upload';

export class MagazinePageService {

    constructor(auth) {
        this.auth = auth;
    }

    async post(payload) {
        return await doFetch(MAGAZINE_CREATE_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async upload(payload) {
        return await doFetch(MAGAZINE_UPLOAD_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async postMany(payload) {
        return await doFetch(MAGAZINE_CREATE_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async uploadMany(payload) {
        return await doFetch(MAGAZINE_UPLOAD_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

}